// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar Specific Styles */
.sidebar-container {
    overflow-y: auto;
    -ms-overflow-style: none;
    /* IE & Edge */
    scrollbar-width: none;
    /* Firefox */
}

.sidebar-container::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari */
}


.sidebar-container {
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    height: 100% !important;
}

.sidebar-logo {
    filter: brightness(1.1);
    transition: transform 0.3s ease;
}

.sidebar-logo:hover {
    transform: scale(1.05);
}

.sidebar-menu-item {
    list-style: none;
    margin: 0;
    padding: 0;
}

.sidebar-menu-link {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    color: white;
    text-decoration: none;
    transition: all 0.3s ease;
    border-radius: 8px;
    margin: 2px 10px;
    position: relative;
    font-weight: 500;
    font-size: 14px;
}

.sidebar-menu-link:hover {
    /* background-color: rgba(255, 255, 255, 0.15); */
    background-color: #022f5a;
    color: white;
    text-decoration: none;
    transform: translateX(5px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.sidebar-menu-link.active {
        background-color: #022f5a;
    /* background-color: rgba(255, 255, 255, 0.2); */
    /* border-left: 4px solid #fbbf24; */
}

.sidebar-menu-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    filter: brightness(0) invert(1);
    transition: all 0.3s ease;
}

.sidebar-menu-text {
    flex: 1 1;
    font-weight: 500;
    letter-spacing: 0.3px;
}

.sidebar-menu-arrow {
    transition: transform 0.2s ease;
}

.sidebar-submenu {
    list-style: none;
    padding: 10px 0;
    margin: 0;
    padding-left: 40px;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 0 0 8px 8px;
    margin: 0 10px;
    margin-top: -10px;
   background: #127ec7;

}


.sidebar-submenu .sidebar-menu-link {
    padding: 8px 15px;
    font-size: 13px;
    /* margin: 1px 0; */
    /* border-radius: 6px; */
    /* background: linear-gradient(to right, #044c92, #0071bc, #022f5a); */
    
}

.sidebar-submenu .sidebar-menu-link:hover {
  /* background: linear-gradient(to right, #044c92, #0071bc, #022f5a); */
  background: #0071bc;
}

.sidebar-logout-container {
    padding: 20px;
    margin-top: auto;
}

.sidebar-logout-btn {
    width: 70%;
    background: #ffffff;
    border: 2px solid transparent;
    border-radius: 25px;
    padding: 8px 10px !important;
    font-weight: 600;
    font-size: 17px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    gap: 8px;
    background-image: linear-gradient(white, white),
        linear-gradient(to right, #0a73b5, #3146a1);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    color: #0a73b5;
    transition: 0.3s ease;
    padding: 4px 16px;
    font-style: none;
}

.sidebar-logout-container a {
    text-decoration: none;
}

.sidebar-logout-btn img {
    width: 20px;
    height: 20px;
    filter: brightness(0) saturate(100%) invert(29%) sepia(99%) saturate(678%) hue-rotate(187deg) brightness(91%) contrast(91%);
    transition: 0.3s ease;
}

.sidebar-logout-btn:hover {
    background-image: linear-gradient(to right, #0a73b5, #3146a1),
        linear-gradient(to right, #0a73b5, #3146a1);
    color: white;
}

.sidebar-logout-btn:hover img {
    filter: brightness(0) invert(1);
}

.sidebar-logout-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.sidebar-wave-pattern {
    position: relative;
    overflow: hidden;
}

.sidebar-wave-pattern::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);
    pointer-events: none;
}

/* Scrollbar Styling */
.sidebar-container::-webkit-scrollbar {
    width: 4px;
}

.sidebar-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
}

.sidebar-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
    .sidebar-container {
        width: 260px;
    }

    .sidebar-menu-link {
        padding: 10px 15px;
        font-size: 13px;
    }

    .sidebar-menu-icon {
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
}

@media (max-width: 480px) {
    .sidebar-container {
        width: 240px;
    }

    .sidebar-logout-btn {
        padding: 10px 15px;
        font-size: 13px;
    }
}

/* Animation for menu items */
@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.sidebar-menu-item {
    animation: slideInLeft 0.3s ease forwards;
}

.sidebar-menu-item:nth-child(1) {
    animation-delay: 0.1s;
}

.sidebar-menu-item:nth-child(2) {
    animation-delay: 0.2s;
}

.sidebar-menu-item:nth-child(3) {
    animation-delay: 0.3s;
}

.sidebar-menu-item:nth-child(4) {
    animation-delay: 0.4s;
}

.sidebar-menu-item:nth-child(5) {
    animation-delay: 0.5s;
}

.sidebar-menu-item:nth-child(6) {
    animation-delay: 0.6s;
}

.sidebar-menu-item:nth-child(7) {
    animation-delay: 0.7s;
}

.sidebar-menu-item:nth-child(8) {
    animation-delay: 0.8s;
}
`, "",{"version":3,"sources":["webpack://./src/Components/admin/sidebar-styles.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;QACQ,yBAAyB;IAC7B,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;GAClB,mBAAmB;;AAEtB;;;AAGA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,sEAAsE;;AAE1E;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,QAAQ;IACR;mDAC+C;IAC/C,6BAA6B;IAC7B,wCAAwC;IACxC,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2HAA2H;IAC3H,qBAAqB;AACzB;;AAEA;IACI;mDAC+C;IAC/C,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,4EAA4E;IAC5E,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["/* Sidebar Specific Styles */\r\n.sidebar-container {\r\n    overflow-y: auto;\r\n    -ms-overflow-style: none;\r\n    /* IE & Edge */\r\n    scrollbar-width: none;\r\n    /* Firefox */\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome, Safari */\r\n}\r\n\r\n\r\n.sidebar-container {\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n    transition: all 0.3s ease;\r\n    height: 100% !important;\r\n}\r\n\r\n.sidebar-logo {\r\n    filter: brightness(1.1);\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n.sidebar-logo:hover {\r\n    transform: scale(1.05);\r\n}\r\n\r\n.sidebar-menu-item {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.sidebar-menu-link {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 12px 20px;\r\n    color: white;\r\n    text-decoration: none;\r\n    transition: all 0.3s ease;\r\n    border-radius: 8px;\r\n    margin: 2px 10px;\r\n    position: relative;\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n}\r\n\r\n.sidebar-menu-link:hover {\r\n    /* background-color: rgba(255, 255, 255, 0.15); */\r\n    background-color: #022f5a;\r\n    color: white;\r\n    text-decoration: none;\r\n    transform: translateX(5px);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.sidebar-menu-link.active {\r\n        background-color: #022f5a;\r\n    /* background-color: rgba(255, 255, 255, 0.2); */\r\n    /* border-left: 4px solid #fbbf24; */\r\n}\r\n\r\n.sidebar-menu-icon {\r\n    width: 20px;\r\n    height: 20px;\r\n    margin-right: 12px;\r\n    filter: brightness(0) invert(1);\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.sidebar-menu-text {\r\n    flex: 1;\r\n    font-weight: 500;\r\n    letter-spacing: 0.3px;\r\n}\r\n\r\n.sidebar-menu-arrow {\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.sidebar-submenu {\r\n    list-style: none;\r\n    padding: 10px 0;\r\n    margin: 0;\r\n    padding-left: 40px;\r\n    background-color: rgba(0, 0, 0, 0.1);\r\n    border-radius: 0 0 8px 8px;\r\n    margin: 0 10px;\r\n    margin-top: -10px;\r\n   background: #127ec7;\r\n\r\n}\r\n\r\n\r\n.sidebar-submenu .sidebar-menu-link {\r\n    padding: 8px 15px;\r\n    font-size: 13px;\r\n    /* margin: 1px 0; */\r\n    /* border-radius: 6px; */\r\n    /* background: linear-gradient(to right, #044c92, #0071bc, #022f5a); */\r\n    \r\n}\r\n\r\n.sidebar-submenu .sidebar-menu-link:hover {\r\n  /* background: linear-gradient(to right, #044c92, #0071bc, #022f5a); */\r\n  background: #0071bc;\r\n}\r\n\r\n.sidebar-logout-container {\r\n    padding: 20px;\r\n    margin-top: auto;\r\n}\r\n\r\n.sidebar-logout-btn {\r\n    width: 70%;\r\n    background: #ffffff;\r\n    border: 2px solid transparent;\r\n    border-radius: 25px;\r\n    padding: 8px 10px !important;\r\n    font-weight: 600;\r\n    font-size: 17px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: auto;\r\n    gap: 8px;\r\n    background-image: linear-gradient(white, white),\r\n        linear-gradient(to right, #0a73b5, #3146a1);\r\n    background-origin: border-box;\r\n    background-clip: padding-box, border-box;\r\n    color: #0a73b5;\r\n    transition: 0.3s ease;\r\n    padding: 4px 16px;\r\n    font-style: none;\r\n}\r\n\r\n.sidebar-logout-container a {\r\n    text-decoration: none;\r\n}\r\n\r\n.sidebar-logout-btn img {\r\n    width: 20px;\r\n    height: 20px;\r\n    filter: brightness(0) saturate(100%) invert(29%) sepia(99%) saturate(678%) hue-rotate(187deg) brightness(91%) contrast(91%);\r\n    transition: 0.3s ease;\r\n}\r\n\r\n.sidebar-logout-btn:hover {\r\n    background-image: linear-gradient(to right, #0a73b5, #3146a1),\r\n        linear-gradient(to right, #0a73b5, #3146a1);\r\n    color: white;\r\n}\r\n\r\n.sidebar-logout-btn:hover img {\r\n    filter: brightness(0) invert(1);\r\n}\r\n\r\n.sidebar-logout-btn:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.sidebar-wave-pattern {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.sidebar-wave-pattern::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%);\r\n    pointer-events: none;\r\n}\r\n\r\n/* Scrollbar Styling */\r\n.sidebar-container::-webkit-scrollbar {\r\n    width: 4px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-track {\r\n    background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb {\r\n    background: rgba(255, 255, 255, 0.3);\r\n    border-radius: 2px;\r\n}\r\n\r\n.sidebar-container::-webkit-scrollbar-thumb:hover {\r\n    background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n    .sidebar-container {\r\n        width: 260px;\r\n    }\r\n\r\n    .sidebar-menu-link {\r\n        padding: 10px 15px;\r\n        font-size: 13px;\r\n    }\r\n\r\n    .sidebar-menu-icon {\r\n        width: 18px;\r\n        height: 18px;\r\n        margin-right: 10px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .sidebar-container {\r\n        width: 240px;\r\n    }\r\n\r\n    .sidebar-logout-btn {\r\n        padding: 10px 15px;\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n/* Animation for menu items */\r\n@keyframes slideInLeft {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateX(-20px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n.sidebar-menu-item {\r\n    animation: slideInLeft 0.3s ease forwards;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(1) {\r\n    animation-delay: 0.1s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(2) {\r\n    animation-delay: 0.2s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(3) {\r\n    animation-delay: 0.3s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(4) {\r\n    animation-delay: 0.4s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(5) {\r\n    animation-delay: 0.5s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(6) {\r\n    animation-delay: 0.6s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(7) {\r\n    animation-delay: 0.7s;\r\n}\r\n\r\n.sidebar-menu-item:nth-child(8) {\r\n    animation-delay: 0.8s;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
